import PropTypes from 'prop-types';
import UserPropType from './user';

const MemberPropType = PropTypes.shape( {
	user: UserPropType.isRequired,
	roleID: PropTypes.string.isRequired
} );

export default MemberPropType;
